module.exports = __webpack_public_path__ + "static/media/6.d75e6ec7.jpg";